import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useAuth, useOrganization } from "hooks";
import { Select } from "components/Form";
import { GET_ADMINS } from "graphql/queries";
import { Spinner } from "components/Loader";
import { PrimaryLink } from "components/Links";

/**
 * OrganizationSalesOwnerSelector
 *
 * @param {Object}  data // organization data
 * @param {Boolean} loading
 */
const OrganizationSalesOwnerSelector = ({ data, loading }) => {
  const { id: currentId } = useAuth();
  const { handleSalesOwnerChange, updatingOrg } = useOrganization();
  const [selection, setSelection] = useState(data?.salesOwner?.id);

  useEffect(() => {
    const salesOwnerId = data?.salesOwner?.id ?? null;
    setSelection(salesOwnerId);
  }, [data?.salesOwner?.id]);

  const handleChange = (selectedOwner) => {
    if (selectedOwner === selection) return;

    setSelection(selectedOwner);
    handleSalesOwnerChange({ orgId: data?.id, salesOwnerId: selectedOwner });
  };

  if (loading) return <Spinner size="1.5rem" />;

  return (
    <div css={styles.container}>
      <Select
        queryKeyName="admins"
        queryName={GET_ADMINS}
        placeholder="Unassigned"
        labelKey="name"
        valueKey="id"
        onChange={(_name, val) => handleChange(val)}
        value={selection}
        loading={loading || updatingOrg}
        isClearable
        disabled={loading || updatingOrg}
      />
      <PrimaryLink onClick={() => handleChange(currentId)} disabled={updatingOrg} css={styles.link}>
        <FormattedMessage id="Organizations.OrganizationSalesOwnerSelector.AssignToMe" />
      </PrimaryLink>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  link: css`
    order: 1;
    align-self: flex-end;
  `,
};

OrganizationSalesOwnerSelector.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    salesOwner: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  loading: PropTypes.bool,
};

export default OrganizationSalesOwnerSelector;
